import { createSlice } from "@reduxjs/toolkit";
import { getCenter } from "../actions/fluxoNSimilar";

interface CenterState {
  sessionCenter: any | null;
  sessionCenterSelect: any | null;
  status: "idle" | "loading" | "ready" | "error";
  error: unknown | null;
  httpStatus: number | null;
  messageStatus: null;
}

const initialState: CenterState = {
  sessionCenter: null,
  sessionCenterSelect: null,
  status: "idle",
  error: null,
  httpStatus: null,
  messageStatus: null,
};
const sessionProductsSlice = createSlice({
  name: "sessionCenter",
  initialState,
  reducers: {
    resetClear(state) {
      return initialState;
    },
    clearProducts(state) {
      state.sessionCenterSelect = null;
    },
    selectProduct(state, action) {
      state.sessionCenterSelect = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCenter.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getCenter.rejected, (state, action) => {
        state.status = "error";
        state.sessionCenter = null;
        state.error = action.payload;
        state.httpStatus = action.payload?.httpStatus || null;
        state.messageStatus = action.error.message;
      })
      .addCase(getCenter.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionCenter = action.payload;
        state.error = null;
        state.httpStatus = 200;
      });
  },
});

export const { resetClear, clearProducts, selectProduct } =
  sessionProductsSlice.actions;
export default sessionProductsSlice.reducer;
